<div class="kt-portlet kt-sc-2">
  <div class="kt-portlet__body">
    <div class="kt-sc__bg kt-sc__bg--layer">
      <img class="rek-building" [src]="'assets/media/bg/pjait-building-' + language + '.svg'" />
    </div>

    <div class="kt-sc__top">
      <div class="kt-sc__content">
        <h2 class="kt-sc__title">{{ 'HOME.ROOT.ENROLLMENT-PORTAL-HEADER.TITLE' | translate }}<br>
          <small>{{ 'HOME.ROOT.ENROLLMENT-PORTAL-HEADER.SUBTITLE' | translate }}</small>
        </h2>
        <h4 class="kt-sc__subtitle" [innerHTML]="enrollmentInfo"></h4>
        <h4 class="kt-sc__subtitle">{{ 'HOME.ROOT.ENROLLMENT-PORTAL-HEADER.ATTENTION' | translate }}</h4>
        <h4 class="kt-sc__subtitle">{{ 'HOME.ROOT.ENROLLMENT-PORTAL-HEADER.ADDITIONAL-INFO' | translate }}</h4>
      </div>
    </div>
  </div>
</div>
